<template>
  <div class="leftres">
    <div>
      <div :class=" showorhide ? 'inputtop' : 'inputtops' ">
        <div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
          <Commondropdownlist ref="hosselect" :options="item.options" :lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" @province="province" @city="city"></Commondropdownlist>
        </div>
        <div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
          <CommonBtngroup :show="showorhide" @showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
        </div>
        <div style="height:10px;">
        </div>
      </div>
      <div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
        <Hospitalarchivestable :tableData="tableData" :total="total" @Export="Export" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Hospitalarchivestable>
      </div>
      <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK" :src="'../assets/icon/icon-errors.png'">
        <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
      </Dialog>
    </div>
  </div>
</template>
<script>
import Commondropdownlist from '../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../components/commongroup.vue'
import Dialog from '../../../components/dialog.vue'
import Hospitalarchivestable from './components/hospitalarchivestable.vue'
import utils from '../../../common/utils'
import { HospitalList, HospitalExport, HospitalGetHospitalType, GetProvince, GetCity, GetDistrict } from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    Hospitalarchivestable,
    Dialog,
    CommonBtngroup
  },
  data() {
    return {
      total: 1,
      pageindex: 1,
      pageSize: 20,
      tableData: [],
      dialogVisibles: false,
      showorhide: true,
      hpCode: "",
      hpName: "",
      HosType: "",
      CreateTime1: "",
      CreateTime2: "",
      authorizeStatus: "",
      ProvinceID: null,
      CityID: null,
      DistrictID: null,
	  Address:'',
      formdata: [
        {
          inputdata: '',
          title: '客户编号',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '220px',
          lablewith: '70px'
        }, {
          inputdata: '',
          title: '客户名称',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '220px',
          lablewith: '70px'
        }, {
          inputdata: '',
          title: '授权状态',
          fontSize: '14px',
          color: '#333333',
          placeholder: '全部',
          types: '',
          inputtype: 'select',
          width: '230px',
          btx: true,
          // lablewith: '90px',
          options: [
            {
              value: '全部',
              key: ''
            }, {
              value: '正式',
              key: '1'
            }, {
              value: '临时',
              key: '0'
            },
          ]
        },
        {
          inputdata: "",
          title: "创建日期",
          fontSize: "14px",
          color: "#333333",
          placeholder: "请输入",
          types: "",
          inputtype: "date",
          width: "140px",
          lablewith: '65px'
        },
        {
          inputdata: '',
          title: '客户分类',
          fontSize: '14px',
          color: '#333333',
          placeholder: '全部',
          types: '',
          inputtype: 'select',
          width: '230px',
          btx: true,
          lablewith: '70px',
          options: [
          ]
        },

        {
          inputdata: '',
          title: '省份',
          fontSize: '14px',
          color: '#333333',
          placeholder: '全部',
          types: '',
          inputtype: 'province',
          width: '230px',
          btx: true,
          lablewith: '70px',
          options: []
        },
        {
          inputdata: '',
          title: '城市',
          fontSize: '14px',
          color: '#333333',
          placeholder: '全部',
          types: '',
          inputtype: 'city',
          width: '230px',
          btx: true,
          lablewith: '80px',
          options: []
        },
        {
          inputdata: '',
          title: '区县',
          fontSize: '14px',
          color: '#333333',
          placeholder: '全部',
          types: '',
          inputtype: 'area',
          width: '310px',
          btx: true,
          lablewith: '70px',
          options: []
        },{
          inputdata: '',
          title: '地址',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '220px',
          lablewith: '70px'
        }
      ]
    }
  },
  mounted() {
    this.hospitalList()
    this.hospitalGetHospitalType()
    this.getProvince()
  },
  methods: {
    // 列表
    async hospitalList() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        data,
        code,
        message
      } = await HospitalList({
        hpCode: this.hpCode,
        hpName: this.hpName,
        authorizeStatus: this.authorizeStatus,
        HosType: this.HosType,
        CreateTime1: this.CreateTime1,
        CreateTime2: this.CreateTime2,
        ProvinceID: this.ProvinceID,
        CityID: this.CityID,
        DistrictID:  this.DistrictID,
        pageSize: this.pageSize,
        pageIndex: this.pageindex,
		Address:this.Address
      })
      //console.log(code, data.data)
      if (code == 0) {
        this.total = data.Count
        this.tableData = data.data
      } else {
        this.$message.error(message)
      }
      loading.close();
    },

    // 导出
    async hospitalExport() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let resexprot = await HospitalExport({
        hpCode: this.hpCode,
        hpName: this.hpName,
        HosType: this.HosType,
        authorizeStatus: this.authorizeStatus,
        CreateTime1: this.CreateTime1,
        CreateTime2: this.CreateTime2,
        ProvinceID: this.ProvinceID,
        CityID: this.CityID,
        DistrictID:  this.DistrictID,
        pageSize: this.pageSize,
        pageIndex: this.pageindex,
		Address:this.Address
      })
      if (resexprot) {
        utils.downloadFile(resexprot, "医院导出", "xlsx")
      } else {
        // 返回json
        this.$message.warning('导出失败');
      }
      loading.close();
      //console.log(resexprot, "resexprot")
    },
    Export() {
      this.hospitalExport()
    },
    async hospitalGetHospitalType() {
      let {
        data,
        code
      } = await HospitalGetHospitalType({
      })
      if (code == 0) {
        this.formdata[4].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Name,
            value: item.Name
          }
          this.formdata[4].options.push(obj)
        })
      }
    },
    reset() {
      this.$refs.hosselect.map((item, index) => {
        if (index == 3) {
          item.startTime = ""
          item.endTime = ""
        }
        item.modelvalue = ""
      })
    },
    cancel() {
      // //console.log('name')
      this.dialogVisibles = false
    },
    dialogOK() {
      // //console.log('name2')
      this.dialogVisibles = false
    },
    hide() {
      this.showorhide = false
      // //console.log("askdas", this.showorhide)

    },
    showclick() {
      this.showorhide = true
    },
    select() {
      try {
        this.pageindex = 1
        this.hpCode = this.$refs.hosselect[0].modelvalue
        this.hpName = this.$refs.hosselect[1].modelvalue
        this.authorizeStatus = this.$refs.hosselect[2].modelvalue
        this.HosType = this.$refs.hosselect[4].modelvalue
        this.CreateTime1 = this.$refs.hosselect[3].startTime
        this.CreateTime2 = this.$refs.hosselect[3].endTime
        this.ProvinceID = this.$refs.hosselect[5].modelvalue
       this.CityID = this.$refs.hosselect[6].modelvalue
      this.DistrictID = this.$refs.hosselect[7].modelvalue
	   this.Address = this.$refs.hosselect[8].modelvalue
        this.hospitalList()
      } catch (error) {
        this.hospitalList()
      }
    },
    province(val) {
      this.$refs.hosselect[6].modelvalue = ''
      this.$refs.hosselect[7].modelvalue = ''
      this.getcity(val)
    },
    city(val) {
      this.getDistrict(val)
      //console.log("jajja", val);
    },
    // 省
    async getProvince() {
      let {
        code,
        data
      } = await GetProvince({

      })
      if (code == 0) {
        this.formdata[5].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Value,
            value: item.Text
          }
          this.formdata[5].options.push(obj)
        })

      }
    },
    // 市
    async getcity(provinceid) {
      let params = {
        ProvinceID: provinceid
      }
      let {
        code,
        data
      } = await GetCity({
        params
      })
      if (code == 0) {
        this.formdata[6].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Value,
            value: item.Text
          }
          this.formdata[6].options.push(obj)
        })
      }
    },
    // 区
    async getDistrict(cityID) {
      let params = {
        CityID: cityID
      }
      let {
        code,
        data
      } = await GetDistrict({
        params
      })
      if (code == 0) {
        this.formdata[7].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Value,
            value: item.Text
          }
          this.formdata[7].options.push(obj)
        })
      }
    },
    handleCurrentChange(pageindex) {
      this.pageindex = pageindex
      this.hospitalList()
      //console.log(pageindex, 'pageindex')

    },
    handleSizeChange(paegSzie) {
      this.pageSize = paegSzie
      this.hospitalList()
    },

  },
  watch: {
    formdata: {
      handler(newVal , oldVal) {
        console.log(newVal);
      },
      deep: true
    },
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 100px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  transition: all 0.3s;
  overflow: hidden;
  position: relative;
}
.inputtops {
  width: 980px;
  height: 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 9px;
  padding-bottom: 64px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s;
}
.Btngroup {
  display: inline-block;
  float: right;
  margin-right: 20px;
  width: 400px;
  height: 50px;
  background-color: #ffffff;
  position: relative;
  bottom: 95px;
}
.Btngroups {
  display: inline-block;
  float: right;
  margin-top: 5px;
  margin-right: 10px;
}
</style>